import { ConfigurationEnum, IEnvironment } from './IEnvironment';
import { buildDate } from './buildDate';
import { appVersion } from './appVersion';
import { appBuildNumber } from './appBuildNumber';

export const defaultValues: IEnvironment = {
  debug: true,
  production: false,
  configuration: ConfigurationEnum.UAT,
  chat: {
    lazyLoadMessagesCount: 10
  },
  buildDate,
  appVersion,
  appBuildNumber,
  storeLinks: {
    ios: 'https://apps.apple.com/ch/app/qvs-mobile-banking/id1530038368',
    android: 'https://play.google.com/store/apps/details?id=ch.quilvest.bankingapp'
  },
  accessApp: {
    appId: 'ch.quilvest.accessapp',
    uri: 'qvsaccess://x-callback-url/authenticate',
    deepLinks: {
      authentication: {
        success: 'qvsbanking://authenticationSuccess',
        cancel: 'qvsbanking://authenticationCancel',
        error: 'qvsbanking://authenticationError'
      },
      paymentConfirmation: {
        success: 'qvsbanking://paymentConfirmationSuccess',
        cancel: 'qvsbanking://paymentConfirmationCancel',
        error: 'qvsbanking://paymentConfirmationError'
      }
    }
  },
  appId: 'ch.quilvest.bankingapp',
  appTitle: 'EFG Mobile Banking App',
  localStorageWhiteList: [],
  defaultTimeout: 30_000,
  notificationDurationMs: 3000,
  contractNumberPatterns: {
    production: /^([\dA-Z]{8})$/,
    uat: /^uat_([\dA-Z]{8})$/,
    test: /^test_([\dA-Z]{8})$/,
    demo: /^api_(\w*)/,
    sandbox: /^wize_(\w*)/
  },
  featureFlags: Object.freeze({
    isChatOnMainScreen: false,
    isCardEnabled: true,
    isInvestmentsEnabled: true,
    isLanguageSwitchEnabled: true,
    darkModeEnabled: true,
    dynamicAssets: false,
    isCgeNewsEnabled: false,
    isCashAccountSlideEnabled: true,
    isDepositaryBanksEnabled: true,
    eDocumentEnabled: true,
    restrictEDocumentForCRM: false,
    customEDocumentCategoryMapping: false,
    showEDocumentDocumentDate: false,
    showCashAccountDetails: false,
    showPerformanceOnPortfolioCard: false,
    showAssetPercentagesOnPortfolioCard: false,
    attachmentOverChatEnabled: true,
    showDebitedNetAmount: true,
    showSimAvailability: false,
    pdfOverChatEnabled: false,
    checkPaymentsAuthorized: false,
    forcedPickClientForRM: false,
    isClientSideSessionTimeoutEnabled: false,
    showPerformanceChartsAxis: false,
    useCumulativePerformanceLineChart: false
  }),
  payment: {
    maxAmount: 10000
  }
};
